module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [(_vm.paymentReceiptNotFound) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "warning"
    }
  }, [_c('strong', [_vm._v("Payment Receipt Not Found")])]) : _vm._e(), _vm._v(" "), (!_vm.paymentReceiptNotFound) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "id": "paymentAlert",
      "role": "warning"
    }
  }, [_c('strong', [_vm._v("Payment Has Been Processed")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Transaction ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_vm._v(_vm._s(_vm.transactionReceipt.transactionId))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Transaction Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_vm._v(_vm._s(_vm.transactionReceipt.transactionDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Card Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_vm._v(_vm._s(_vm.transactionReceipt.cardType))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Card Number (last 4 digits)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_vm._v(_vm._s(_vm.transactionReceipt.cardNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_vm._v(_vm._s(_vm.transactionReceipt.amount))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Note")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_vm._v(_vm._s(_vm.transactionReceipt.note))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.paymentReceiptNotFound) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "receiptReport"
    },
    on: {
      "click": _vm.genReceiptReport
    }
  }, [_vm._v("Print Receipt")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "name": "button2",
      "type": "submit"
    },
    on: {
      "click": _vm.goFileSearch
    }
  }, [_vm._v("Return to File Search")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDebug),
      expression: "isDebug"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('h4', [_vm._v("transactionReceipt: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.transactionReceipt))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("****** Debug ******")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-636c17ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/FileSearchPaymentReceipt.vue
// module id = 949
// module chunks = 1